// store all API functions in this file
export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '782f436ae4msh8ca92d542c59699p17c45fjsn96fbb8c6dc8a',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5"
export const WEATHER_API_KEY = "56c0e41a32a627054ccb472abb713a65"